import { Icon } from '@pella/sash-framework';
import { convertISO } from '../../../utils';

import * as classes from './RequestCardHistory.module.css';

/**
 * Request Card History molecule
 * @param {Local.RequestCardHistoryProps} props - Component props
 */
export const RequestCardHistory = ({ title, user, date, holdReason }) => (
  <div>
    <div className={classes.title}>{title}</div>
    <div className={classes.info}>
      <Icon name='account_circle' size={16} weight={700} />
      <div className={classes.user}>{user}</div>
    </div>
    <div className={classes.info}>
      <Icon name='schedule' size={16} weight={700} />
      <div>{convertISO(date)}</div>
    </div>
    {Boolean(holdReason) && (
      <div className={classes.info}>
        <Icon name='info' size={16} weight={700} />
        <div className={classes.info}>{holdReason}</div>
      </div>
    )}
  </div>
);
